import styled, { keyframes } from 'styled-components';
import InfiniteSlider from '../animation/InfiniteSlider';
import YellowImage1 from '../../assets/images/yellow_1.png';
import YellowImage2 from '../../assets/images/yellow_2.png';
import YellowImage3 from '../../assets/images/yellow_3.png';
import YellowImage4 from '../../assets/images/yellow_4.png';
import YellowImage5 from '../../assets/images/yellow_5.png';
import YellowImage6 from '../../assets/images/yellow_6.png';

const images = [YellowImage3, YellowImage4, YellowImage5, YellowImage6];

const moveAnimation = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const YellowSection = () => {
  return (
    <StyledSection>
      <h2 className="a11y-hidden">봄의 요정</h2>
      <StyledUl>
        <li>
          <img src={YellowImage1} alt="" />
        </li>
        <li>
          <img src={YellowImage2} alt="" />
        </li>
      </StyledUl>
      <InfiniteSlider>
        {(isVisible) => (
          <StyledSlideUl className={isVisible && 'visible'}>
            {[...images, ...images].map((image, index) => (
              <li key={index}>
                <img src={image} alt="" />
              </li>
            ))}
          </StyledSlideUl>
        )}
      </InfiniteSlider>
    </StyledSection>
  );
};

const StyledSection = styled.section`
  overflow: hidden;
`;

const StyledUl = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const StyledSlideUl = styled.ul`
  display: flex;
  gap: 2rem;
  padding: 3rem 2rem;
  background-color: var(--yellow);
  width: max-content;

  li {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 20rem;
    padding: 0 0 12rem;

    &:nth-child(even) {
      padding: 12rem 0 0;
    }

    img {
      width: 100%;
    }
  }

  &.visible {
    animation: ${moveAnimation} 15s linear infinite;
  }
`;

export default YellowSection;
